import { Component, OnInit,ContentChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from "../../../services/admin.service";
import Swal from 'sweetalert2';

declare var iziToast: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    

'./login.component.css'
]
})


export class LoginComponent implements OnInit {

  @Output() cerrarModal = new EventEmitter<any>();
  public user: any={};
  public usuario :any={};
  public token :any = {};
  public recordarUsuario = false;
  public isSubmitting = false;
  fieldTextType: boolean = false;

  private readonly emailRecordadoKey = 'vabait_recordar_email';

  constructor(
    private _adminService : AdminService,
    private _router : Router

  ) {

    this.token = this._adminService.getToken();
    
    
    
  }

  ngOnInit(): void {
    const emailRecordado = localStorage.getItem(this.emailRecordadoKey);
    if (emailRecordado) {
      this.user.email = emailRecordado;
      this.recordarUsuario = true;
    }

    if(this.token)
    {
      this._router.navigate(['/panel']);
    }else{
      // Mantener componente
    }
  }

  login(loginForm: any) {
    if (!loginForm.valid) {
      Swal.fire({
        icon:'error',
        text:'Debe escribir el correo y la contraseña que te asigno tu asesor para ingresar al sistema'
      });
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
      let data = {
        email: this.user.email,
        password: this.user.password
      }

      this._adminService.login_admin(data).subscribe(
        response => {
          if (response.data == undefined) {
            this.isSubmitting = false;
            iziToast.show({
              title: 'Success',
              titleColor: 'FF0000',
              class: 'text-danger',
              color:'green',
              position: 'topRight',
              message:response.message
        });
          } else {
            this.usuario = response.data;

            if (this.recordarUsuario) {
              localStorage.setItem(this.emailRecordadoKey, this.user.email);
            } else {
              localStorage.removeItem(this.emailRecordadoKey);
            }

            localStorage.setItem('token', response.token);
            //localStorage.setItem('_id',response.data._id);
            
            //this._router.navigate(['/']);
            this.cerrarModal.emit(false);
           // location.href ="https://admin.vabait.co/#/inicio";

           let ruta: string;
           if(this.usuario.rol == 'admin'){
            console.log(this.usuario.rol)
            ruta = '/panel/BI';
           }else if(this.usuario.rol == 'cliente') {
            ruta = '/panel/consultar_inventario_clientes';
           }else if(this.usuario.rol == 'propietario'){
            ruta = '/panel/consultar_inventario_propietario';
           }else if(this.usuario.rol == 'asesor'){
            ruta = '/panel/propiedades';
           }

           if (ruta) {
            this._router.navigate([ruta]).then(
              navigated => { if (!navigated) this.isSubmitting = false; },
              () => { this.isSubmitting = false; }
            );
           } else {
            this.isSubmitting = false;
           }

        } },
        error => {
          this.isSubmitting = false;
          Swal.fire({
            icon:'error',
            text:'El correo o la contraseña con la que estas intentando ingresar son incorrectos'
          });
        }
      );

  }


  showPassword()
  {
    this.fieldTextType = !this.fieldTextType
  }
 


}
